var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMetricValueGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.14258 0C1.93359 0 0.142578 1.79083 0.142578 4V12C0.142578 14.2092 1.93359 16 4.14258 16H12.1426C14.3516 16 16.1426 14.2092 16.1426 12V4C16.1426 1.79083 14.3516 0 12.1426 0H4.14258Z",
    fill: "#5F6877"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.89258 2C2.47836 2 2.14258 2.33579 2.14258 2.75V13.25C2.14258 13.6642 2.47836 14 2.89258 14H6.64258V13.25H3.64258V12.5H6.64258V11.75H5.14258V11H6.64258V10.25H3.64258V9.5H6.64258V8.75H5.14258V8H6.64258V7.25H3.64258V6.5H6.64258V3.5H7.39258V6.5H8.14258V5H8.89258V6.5H9.64258V3.5H10.3926V6.5H11.1426V5H11.8926V6.5H12.6426V3.5H13.3926V6.5H14.1426V2.75C14.1426 2.33579 13.8068 2 13.3926 2H2.89258Z",
    fill: "#9E9DAF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetricValueGray);
export default __webpack_public_path__ + "static/media/metric-valueGray.9c15e0f85b99a142e30c94510cf00524.svg";
export { ForwardRef as ReactComponent };